'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var LayoutColumn = function (_React$Component) {
  _inherits(LayoutColumn, _React$Component);

  function LayoutColumn() {
    _classCallCheck(this, LayoutColumn);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  LayoutColumn.prototype.render = function render() {
    var width = (this.props.width * 100).toPrecision(5) + '%';
    return React.createElement(
      'div',
      { className: 'cf-layout__column', style: { width: width } },
      this.props.children
    );
  };

  return LayoutColumn;
}(React.Component);

LayoutColumn.propTypes = {
  width: PropTypes.number.isRequired
};


module.exports = LayoutColumn;